import { inject, Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { EventsService } from '@services/events/events.service';
import { StorageService } from '@services/storage/storage.service';
import { UtilService } from '@services/util/util.service';
import { VariablesService } from '@services/variables/variables.service';
import { IOrder } from '@models/order.model';
import { NgIf } from '@angular/common';
import { PaymentSuccessfullComponent } from './components/payment-successfull/payment-successfull.component';
import { SipQuizQuestionComponent } from './components/sip-quiz-question/sip-quiz-question.component';
import { RedeemThankYouPageComponent } from './components/redeem-thank-you-page/redeem-thank-you-page.component';

@Component({
  selector: 'app-sip-quiz-v2',
  standalone: true,
  imports: [
    NgIf,
    PaymentSuccessfullComponent,
    SipQuizQuestionComponent,
    RedeemThankYouPageComponent
  ],
  templateUrl: './sip-quiz-v2.component.html',
  styleUrls: ['./sip-quiz-v2.component.scss']
})
export class SipQuizV2Component {

  private events = inject(EventsService);
  private vars = inject(VariablesService);
  private util = inject(UtilService);
  private activatedRoute = inject(ActivatedRoute);
  public storage = inject(StorageService);

  @Input() order: IOrder;
  public prizeAmount: number;
  public takeQuiz = false;
  public showQuiz = true;
  private subscription: Subscription = new Subscription();

  ngOnInit() {
    const showQuiz = this.storage.getFromSession('showQuiz');
    if (showQuiz !== null) {
      this.showQuiz = showQuiz;
    }
    this.activatedRoute.queryParams.subscribe(params => {
      if (params.st) {
        if (params.st === 'f') {
          this.takeQuiz = true;
        }
      }
    });
  }

  ngOnChanges() {
    this.prizeAmount = this.getPrizeAmount();
  }

  /**
   * Toggles quiz page
   */
  toggleQuiz(event): void {
    this.takeQuiz = !this.takeQuiz;
    if (this.takeQuiz) {
      this.storage.addSessionData('showQuiz', false.toString())
    }
    this.subscription = this.events.sendSystemEvent({
      eventName: 'take_quiz',
      info_3: 'impact'
    }).subscribe(_ => _);
  }

  /**
   * Gets prize amount based on currency
   * @returns prize amount
   */
  private getPrizeAmount(): number {
    if (this.order) {
      return this.util.getPrizeAmount(this.order.iso_currency);
    }
    return null;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
